import useAxiosInterceptor from 'src/services/interceptor';
import { patientApiPaths } from '../constants';

class EpisodeOfCareService {
  private axiosInstance;

  constructor() {
    this.axiosInstance = useAxiosInterceptor();
  }

  getEpisodeOfCare = (payload: any) => {
    return this.axiosInstance.get(
      `${patientApiPaths.createPatient}${patientApiPaths.episodeOfCare}/${payload?.patientId}`,
      {
        params: payload,
      }
    );
  };
  getSingleEpisodeOfCare = (payload: any) => {
    return this.axiosInstance.get(
      `${patientApiPaths.createPatient}${patientApiPaths.episodeOfCare}/id/${payload?.episodeOfCareId}`,
      {
        params: payload,
      }
    );
  };
  closeEpisodeOfCare = (payload: any) => {
    return this.axiosInstance.put(
      `${patientApiPaths.createPatient}${patientApiPaths.episodeOfCare}/change-status/${payload?.episodeOfCareId}`,
      null,
      {
        params: {
          endDate: payload?.endDate ? payload?.endDate : null,
          status: payload?.status,
        },
      }
    );
  };
  createEpisodeOfCare = (payload: any) => {
    return this.axiosInstance.post(
      `${patientApiPaths.createPatient}${patientApiPaths.episodeOfCare}/${payload?.patientId}`,
      payload
    );
  };
  editEpisodeOfCare = (payload: any) => {
    return this.axiosInstance.put(
      `${patientApiPaths.createPatient}${patientApiPaths.episodeOfCare}/${payload?.episodeOfCareId}`,
      payload
    );
  };
  getEpisodeOfCareRequiredDocument = (payload: any) => {
    return this.axiosInstance.get(`${patientApiPaths.episodeOfCareGetRequiredDocument}`, {
      params: payload.params,
      signal: payload?.signal,
    });
  };
}

const episodeOfCareService = new EpisodeOfCareService();

Object.freeze(episodeOfCareService);

export default episodeOfCareService;
